import { render, staticRenderFns } from "./AuthorNew.vue?vue&type=template&id=7e1bb1b3&"
import script from "./AuthorNew.vue?vue&type=script&lang=js&"
export * from "./AuthorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports